
import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Education from './components/Education';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Navigation from './components/Navigation';

const HomePage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`min-h-screen bg-gradient-to-br from-amber-50 via-yellow-50 to-green-50 transition-all duration-1500 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
      <Navigation />
      <main className="relative">
        {/* Background texture overlay */}
        <div className="fixed inset-0 bg-leaf-pattern opacity-30 pointer-events-none z-0"></div>
        
        <div className="relative z-10">
          <Hero />
          <About />
          <Skills />
          <Experience />
          <Education />
          <Projects />
          <Contact />
        </div>
      </main>
      
      {/* Enhanced Footer */}
      <footer className="relative bg-gradient-to-r from-amber-900 via-yellow-900 to-green-900 text-white py-8 md:py-12 overflow-hidden">
        {/* Background pattern */}
        <div className="absolute inset-0 bg-wood-pattern opacity-20"></div>
        
        <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-6 text-center">
          <div className="mb-4 md:mb-6">
            <h3 className="text-xl md:text-2xl font-serif gradient-text mb-2">Afiki Rajabo Chiwaya</h3>
            <p className="text-amber-200 text-sm md:text-base">Agricultural Professional & Sustainable Farming Expert</p>
          </div>
          
          <p className="text-amber-300/80 mb-4 md:mb-6 text-sm md:text-lg">© 2024 Afiki Rajabo Chiwaya. All rights reserved.</p>
          
          <div className="flex justify-center space-x-6 md:space-x-8 mb-6 md:mb-8">
            <a 
              href="mailto:afikirc@gmail.com" 
              className="group text-amber-300 hover:text-yellow-300 transition-all duration-300 transform hover:scale-110"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 bg-amber-800/50 rounded-full flex items-center justify-center group-hover:bg-amber-700/70 transition-all duration-300 hover-lift">
                <i className="ri-mail-line text-lg md:text-xl group-hover:animate-bounce"></i>
              </div>
            </a>
            <a 
              href="tel:+27782333696" 
              className="group text-amber-300 hover:text-yellow-300 transition-all duration-300 transform hover:scale-110"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 bg-amber-800/50 rounded-full flex items-center justify-center group-hover:bg-amber-700/70 transition-all duration-300 hover-lift">
                <i className="ri-phone-line text-lg md:text-xl group-hover:animate-bounce"></i>
              </div>
            </a>
          </div>
          
          <div className="pt-4 md:pt-6 border-t border-amber-700/50">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center text-amber-400/80 hover:text-amber-300 text-xs md:text-sm font-medium transition-colors duration-300"
            >
              <span className="mr-2">🌱</span>
              <span>Created by Naledi Leshakhe</span>
            </a>
          </div>
        </div>
        
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 via-yellow-500 to-green-500"></div>
      </footer>
    </div>
  );
};

export default HomePage;
